// The columns the Accelerator's staff side reads and writes (docs/data-model.md 10.6.1), in 1 place,
// so the screens, the e2e recording (tests/e2e/fixtures/admin-mastermind/print-sql.mjs) and its replay
// ask for the same thing. Pure: no imports. Each list differs from the other screens' reads of the same
// tables (People's, Recordings and dates', the Library's), so a replay never answers 1 with another's.
export const MM_COLUMNS = {
  // a mastermind's sessions, for the session a month is set at (staff read every session)
  sessions: 'id, product_id, cohort_id, number, title, starts_at, duration_minutes, status',
  // the Masterminds section: a mastermind's groups and their WhatsApp links
  groups: 'id, product_id, name, kind, number, sort_order, schedule_label',
  links: 'whatsapp_invite_url, cohort_id',
  // a win as it's written back
  wins: 'id, person_id, product_id, title, category, win_date, detail, shareable',
  // a group as it's written back, and the session for every group
  cohorts: 'id, product_id, name, kind, schedule_label, number, sort_order',
  every: 'id, product_id, cohort_id, title, starts_at, duration_minutes, status',
  // a register line as Mark all present writes it
  attendance: 'session_id, person_id, status, source, note, recorded_by, recorded_at',
  // the after-session checklist (the critique's admin 7): the sessions to come with their Zoom links, and which held
  // sessions have a recording, each read on its own so the sessions above stay as they are
  nextSessions: 'id, product_id, cohort_id, starts_at, duration_minutes, status, zoom_join_url',
  recordings: 'id, product_id, cohort_id, session_id',
  // Guarantee rules: a mastermind's numbers, in hub.accountability_rules since migration 81 (owner and admin read it)
  rules: 'product_id, rules',
}
export const flatMm = key => MM_COLUMNS[key].replace(/\s+/g, '')
